import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCartShadowIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 101,
	height: 95,
	viewBox: "0 0 101 95",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50.5,
			cy: 90,
			rx: 50.5,
			ry: 5,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.4998 84.3327C36.6169 84.3327 38.3332 82.6164 38.3332 80.4994C38.3332 78.3823 36.6169 76.666 34.4998 76.666C32.3827 76.666 30.6665 78.3823 30.6665 80.4994C30.6665 82.6164 32.3827 84.3327 34.4998 84.3327Z",
			stroke: "#949494",
			strokeWidth: 8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.6668 84.3327C78.7839 84.3327 80.5002 82.6164 80.5002 80.4994C80.5002 78.3823 78.7839 76.666 76.6668 76.666C74.5497 76.666 72.8335 78.3823 72.8335 80.4994C72.8335 82.6164 74.5497 84.3327 76.6668 84.3327Z",
			stroke: "#949494",
			strokeWidth: 8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.8335 3.83398H19.1668L29.4402 55.1623C29.7907 56.9272 30.7508 58.5125 32.1524 59.6408C33.554 60.7691 35.3078 61.3685 37.1068 61.334H74.3668C76.1658 61.3685 77.9196 60.7691 79.3212 59.6408C80.7228 58.5125 81.683 56.9272 82.0335 55.1623L88.1668 23.0007H23.0002",
			stroke: "#949494",
			strokeWidth: 8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCartShadowIcon;
